import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsx } from 'react/jsx-runtime';

var PlayIcon = ZepIcon_default((props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M6 6.741c0-1.543 1.674-2.505 3.008-1.727l9.015 5.259c1.323.771 1.323 2.683 0 3.455l-9.015 5.259C7.674 19.765 6 18.803 6 17.259V6.741Zm11.015 5.26L8 6.74V17.26L17.015 12Z",
    fill: props.fill || "currentColor"
  }
) }));

export { PlayIcon };
